import loadable from "@loadable/component";
import publicRoutes from "./public-routes";

// Page Not Found
import PageNotFound from "src/scenes/PageNotFound";

// Maintenance
import Maintenance from "src/scenes/Maintenance";

// Version
import FeVersion from "src/scenes/FeVersion";

// Verification from Email
const VerificationFromEmailPage = loadable(() =>
  import(/* webpackChunkName: "verificationEmail" */ "src/scenes/NewVerification/pages/VerificationFromEmailPage")
);

// Profile Email
const VerifyProfileEmailPage = loadable(() =>
  import(/* webpackChunkName: "verificationEmail" */ "src/scenes/Settings/pages/VerifyProfileEmailPage")
);

// Component with Guest Layout
const LoginPage = loadable(() => import("src/scenes/Guest/pages/LoginPage"));
// TEMP (2026-10-24): sign-up hidden while platform abuse is handled. Uncomment to restore.
// const NewUserPage = loadable(() => import("src/scenes/Guest/pages/NewUserPage"));
// const ExistingUserPage = loadable(() => import("src/scenes/Guest/pages/ExistingUserPage"));
const ContactSalesPage = loadable(() => import("src/scenes/Guest/pages/ContactSalesPage"));
const OTPCodePage = loadable(() => import("src/scenes/Guest/pages/OTPCodePage"));
const OTPVerifyPage = loadable(() => import("src/scenes/Guest/pages/OTPVerifyPage"));
const DeviceVerifyPage = loadable(() => import("src/scenes/Guest/pages/DeviceVerifyPage"));
const OTPDeviceVerifyPage = loadable(() => import("src/scenes/Guest/pages/DeviceVerifyOTPPage"));
const ResetPasswordPage = loadable(() => import("src/scenes/Guest/pages/ResetPasswordPage"));

// Guest
const NewPasswordPage = loadable(() => import("src/scenes/Guest/pages/NewPasswordPage"));
const ExpiredPage = loadable(() => import("src/scenes/Guest/pages/ExpiredPage"));

/*
 * Please uncomment this line yourself if you want to see the page
 * And make sure that's only on your local environment
 */
// Style Guides
const StyleGuides = loadable(() => import(/* webpackChunkName: "styleGuide" */ "src/scenes/StyleGuides"));

// Routes with GuestLayout
export const guestRoutes = [
  { ...publicRoutes.login, component: LoginPage },
  // TEMP (2026-10-24): sign-up hidden while platform abuse is handled. Uncomment to restore.
  // { ...publicRoutes.newUser, component: NewUserPage },
  // { ...publicRoutes.existingUser, component: ExistingUserPage },
  { ...publicRoutes.otpCode, component: OTPCodePage },
  { ...publicRoutes.otpVerify, component: OTPVerifyPage },
  { ...publicRoutes.deviceVerify, component: DeviceVerifyPage },
  { ...publicRoutes.otpDeviceVerify, component: OTPDeviceVerifyPage },
  { ...publicRoutes.resetPassword, component: ResetPasswordPage }
];

const routes = [
  // Guest
  { ...publicRoutes.newPassword, component: NewPasswordPage },
  { ...publicRoutes.expired, component: ExpiredPage },
  { ...publicRoutes.contactSales, component: ContactSalesPage },

  // Verification from Email
  { ...publicRoutes.verificationFromEmail, component: VerificationFromEmailPage },

  // Verification email from update email
  { ...publicRoutes.verifyProfileEmail, component: VerifyProfileEmailPage },

  // Page Not Found
  { ...publicRoutes.notFound, component: PageNotFound },

  // Maintenance
  { ...publicRoutes.maintenance, component: Maintenance },

  // Version
  { ...publicRoutes.feVersion, component: FeVersion },

  // Style Guide
  { ...publicRoutes.styleGuide, component: StyleGuides }
];

export default routes;
